const ssoErrorCodes = {
  SSO_SESSION_FAILED_ERROR: 'sso.session.failed',
};

export default ssoErrorCodes;
